import { Info } from "lucide-react";
import { useAuthStore } from "../store/useAuthStore.ts";

/**
 * Shown wherever a page has nothing to show because the user has not been
 * added to any review yet, instead of an empty list or a spinner that never
 * stops. Coordinators and admins see every review, so they never get this.
 */
export function NoReviewNotice() {
  const { user } = useAuthStore();
  const role = user?.role;

  const [title, body] =
    role === "OBSERVER"
      ? [
          "Your account is an observer account",
          "Observers can follow the reviews but cannot screen or extract papers. If you are joining a review team, ask a coordinator to upgrade your account to Reviewer and add you to the review.",
        ]
      : role === "SUB_TEAM_LEADER"
        ? [
            "You have not been allocated a review yet",
            "Once a coordinator adds you to the review you are leading, it will appear here and you can manage its reviewers and papers. Please contact a coordinator if you are expecting one.",
          ]
        : [
            "You have not been allocated a review yet",
            "Once you are added to a review, its papers will appear here for you to screen. Please contact your sub-team leader or a coordinator if you are expecting one.",
          ];

  return (
    <div className="border rounded-lg bg-card p-6 flex gap-3 items-start max-w-2xl">
      <Info className="h-5 w-5 text-primary shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-semibold">{title}</p>
        <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{body}</p>
      </div>
    </div>
  );
}
